import Vue from 'vue';
import Router from 'vue-router';
import NotFound from './views/NotFound.vue';

const config = require('../config.json');

Vue.use(Router);

const routes = [
  {
    path: '/',
    redirect: '/editor',
  },
  {
    path: '*',
    name: 'not-found',
    component: NotFound,
  },
  {
    path: '/editor',
    name: 'editor-home',
    component: () => import(/* webpackChunkName: "editor" */ './views/Editor'),
  },
  {
    path: '/editor/:id',
    name: 'editor',
    component: () => import(/* webpackChunkName: "editor" */ './views/Editor'),
  },
  {
    path: '/verbose',
    name: 'verbose-home',
    component: () => import(/* webpackChunkName: "verbose" */ './views/Verbose'),
  },
  {
    path: '/verbose/:id',
    name: 'verbose',
    component: () => import(/* webpackChunkName: "verbose" */ './views/Verbose'),
  },
  {
    path: '/treeview',
    name: 'tree-home',
    component: () => import(/* webpackChunkName: "tree" */ './views/Tree'),
  },
  {
    path: '/treeview/:id',
    name: 'tree',
    component: () => import(/* webpackChunkName: "tree" */ './views/Tree'),
  },
];

// HydraNet fork: the marketing routes (download/sponsor/wiki) are dropped. webpack compiles any lazy
// import() regardless of the runtime selfHosted flag, and the wiki view statically imports the LuckPerms
// wiki submodule (absent in this fork), so the routes are removed here entirely rather than runtime-gated.

export default new Router({
  mode: 'history',
  base: config.base,
  routes,
});
